"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSDeactivateLineComponent = void 0;
const core_1 = require("@angular/core");
const router_1 = require("@angular/router");
const ng_bootstrap_1 = require("@ng-bootstrap/ng-bootstrap");
const device_service_1 = require("../../devices/services/device.service");
const generic_content_service_1 = require("../services/generic.content.service");
class CSDeactivateLineComponent {
    constructor(router, deviceService, modalService, genericContentService) {
        this.router = router;
        this.deviceService = deviceService;
        this.modalService = modalService;
        this.genericContentService = genericContentService;
        this.businessUrl = '/business';
        this.deviceReturn = false;
        this.callAccDetails = new core_1.EventEmitter();
        this.resetDeactivateLine = new core_1.EventEmitter();
    }
    ngOnChanges(changes) {
        if (this.isDeactivateLine) {
            this.getDeactivateLineContent();
            if (this.isSingleLineFlow) {
                this.options = { size: 'lg', windowClass: 'supend-info', backdrop: 'static' };
            }
            else {
                this.options = { size: 'lg', windowClass: 'supend-info' };
            }
            this.open(this.deactivateLineContent);
        }
    }
    getDeactivateLineContent() {
        this.modalLoader = true;
        this.genericContentService.getGenericContent('genericDeactivateLineInfo').subscribe((data) => {
            this.genericContentDeactivateLine = data.contentText;
            this.modalLoader = false;
        }, (err) => {
            this.modalError = err;
            this.modalLoader = false;
        });
    }
    open(content) {
        this.isDeactivationSuccessful = false;
        this.modalError = null;
        this.modalRef = this.modalService.open(content, this.options);
        this.modalRef.result.then(() => {
        }, (close) => {
            this.emitResetDeactivateLineValue();
        });
    }
    returnDevice() {
        this.modalLoader = false;
        this.deviceReturn = true;
    }
    deactivateLine(subId) {
        this.modalLoader = true;
        this.modalError = null;
        this.deviceService.deactivateLine(subId)
            .subscribe((deactivationInfo) => {
            this.isDeactivationSuccessful = deactivationInfo;
            this.callAccDetails.emit(true);
            this.modalLoader = false;
        }, () => {
            this.getDeactivateLineErrorContent();
        });
    }
    closeModal() {
        this.emitResetDeactivateLineValue();
        this.modalRef.close();
    }
    emitResetDeactivateLineValue() {
        this.resetDeactivateLine.emit(true);
    }
    returnToDashboard() {
        this.modalRef.close();
        this.router.navigate([this.businessUrl]);
    }
    getDeactivateLineErrorContent() {
        this.modalLoader = true;
        this.genericContentService.getGenericContent('genericErrorDeactivateLine').subscribe((data) => {
            this.modalError = this.setErrorMessage(data === null || data === void 0 ? void 0 : data.contentText);
            this.modalLoader = false;
        }, (err) => {
            this.modalError = err;
            this.modalLoader = false;
        });
    }
    setErrorMessage(errorMessage) {
        const errorMsg = {
            errorMessage
        };
        return errorMsg;
    }
}
exports.CSDeactivateLineComponent = CSDeactivateLineComponent;
//# sourceMappingURL=deactivate-line.component.js.map